<span [class]="horario">
  {{ horario?.inicio | min2time: false }} - {{ horario?.final | min2time }} <span class="ms-1 icon-o-clock-2 o-50"></span>{{
  horario?.tempoEstimadoSeparacaoMin }}<span class="o-50">min</span>
</span>
